import { getAccessToken, setLS } from "../../util";
import { baseURL } from "../../constants";

const endPoint = "/articles";
const path = `${baseURL}${endPoint}`;

export async function addArticle(data) {
  const at = getAccessToken();
  const url = `${path}/`;
  const response = await fetch(url, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: `Bearer ${at}`,
    },
    method: "POST",
    body: JSON.stringify(data),
  });

  if (response.status === 200) {
    setLS("SP", JSON.stringify([]));
    return true;
  }
  return false;
}

export async function getArticles() {
  const at = getAccessToken();
  const url = `${path}/`;
  const response = await fetch(url, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: `Bearer ${at}`,
    },
  });

  if (response.status === 200) {
    const json = await response.json();
    console.log(json);
    return json;
  }
  return false;
}

export async function updateArticle(id, data) {
  const at = getAccessToken();
  const url = `${path}/${id}`;
  const response = await fetch(url, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: `Bearer ${at}`,
    },
    method: "PATCH",
    body: JSON.stringify(data),
  });

  if (response.status === 200) {
    return true;
  }
  return false;
}
